import axiosGraphQL from './GraphQL/axiosGraphQL';
import { GrossProfitQuery } from './GraphQL/Queries/grossProfitQuery';
import {
  GrossProfitVariables,
  IGetAgeComboBox,
  IGetGrossProfit,
  IUpdateCompoundInterest,
} from './GraphQL/Variables/GrossProfitVariables';

export const GrossProfitApis = {
  getGrossProfit: async (params: IGetGrossProfit): Promise<any> => {
    return await axiosGraphQL.post('/graphql', {
      query: GrossProfitQuery.GET_GROSS_PROFIT,
      variables: GrossProfitVariables.getGrossProfit(params),
    });
  },
  saveGrossProfit: async (params: any): Promise<any> => {
    return await axiosGraphQL.post('/graphql', {
      query: GrossProfitQuery.SAVE_GROSS_PROFIT,
      variables: GrossProfitVariables.saveGrossProfit(params),
    });
  },
  getCbxTpye: async () => {
    return await axiosGraphQL.post('/graphql', {
      query: GrossProfitQuery.GET_CBX_TYPE,
      variables: GrossProfitVariables.getCbxTpye({}),
    });
  },

  getCbxGoldAge: async () => {
    return await axiosGraphQL.post('/graphql', {
      query: GrossProfitQuery.GET_CBX_GOLD_AGE,
      variables: GrossProfitVariables.getCbxGoldAge({}),
    });
  },

  // Get Age ComboBox
  getAgeComboBox: async (params: IGetAgeComboBox) => {
    return await axiosGraphQL.post('/graphql', {
      query: GrossProfitQuery.GET_AGE_COMBOBOX,
      variables: GrossProfitVariables.getAgeComboBox(params),
    });
  },

  updateCompoundInterest: async (input: IUpdateCompoundInterest) => {
    return await axiosGraphQL.post('/graphql', {
      query: GrossProfitQuery.UPDATE_COMPOUND_INTEREST,
      variables: GrossProfitVariables.updateCompoundInterest(input),
    });
  },
};
